module.exports = __webpack_public_path__ + "static/media/icon.c59c961c.png";